@import (reference) '../../../../constants/spacing.module.less';

.instruction-text {
  font-weight: 500;
}

.warehouse-text {
  color: var(--grey-600);
}

.drawer-section {
  background-color: var(--white);
  border-radius: @space-8;
  border: 1px solid var(--grey-300);
  padding: @space-16;
  min-height: fit-content;
  height: 100%;
  overflow: hidden;
}

.resizable-section {
  flex-shrink: 0;
}

.top-section {
  margin-bottom: @space-24;
}

.banner {
  width: max-content;
  border-radius: @space-4;
}
